<div *ngIf="!data.error" class="mat-dialog-title">Wurden alle Unterlagen eindeutig erkannt?</div>
<div *ngIf="data.error" class="mat-dialog-title">Fehler</div>
<mat-dialog-content>
    <mat-form-field *ngIf="!data.error">
        <textarea
                class="full-width"
                matInput
                placeholder="Kommentar"
                [(ngModel)]="data.comment"
        ></textarea>
    </mat-form-field>
    <div *ngIf="data.error">
        <p>Es ist folgender Fehler aufgetreten: <i>{{ data.error }}</i></p>
        <p>Soll dieses Dokument als fehlerhaft gespeichert werden?</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button *ngIf="!data.error" mat-flat-button color="primary" (click)="onSuccess()" cdkFocusInitial>JA</button>
    <button *ngIf="data.error" mat-flat-button color="primary" (click)="onErrorSuccess()" cdkFocusInitial>JA</button>
    <button *ngIf="!data.error" mat-flat-button color="accent" (click)="onReviewRequest()">NEIN</button>
    <button mat-flat-button (click)="onBack()">ABBRECHEN</button>
</mat-dialog-actions>
